type Point = {x: number; y: number};

/** Interpolate samples with bounded cubic tangents, preserving peaks and plateaus. */
export function monotonePath(points: readonly Point[]): string {
  const linear = () => points.map((p, i) => `${i ? 'L' : 'M'}${p.x},${p.y}`).join(' ');
  if (points.length < 3 || points.some((p, i) => i > 0 && p.x <= points[i - 1].x)) return linear();
  const slopes = points.slice(1).map((p, i) => (p.y - points[i].y) / (p.x - points[i].x));
  const tangents = points.map((_, i) => {
    if (i === 0) return slopes[0];
    if (i === points.length - 1) return slopes[i - 1];
    return slopes[i - 1] * slopes[i] <= 0 ? 0 : (slopes[i - 1] + slopes[i]) / 2;
  });
  slopes.forEach((slope, i) => {
    if (slope === 0) {
      tangents[i] = tangents[i + 1] = 0;
      return;
    }
    const magnitude = Math.hypot(tangents[i] / slope, tangents[i + 1] / slope);
    if (magnitude > 3) {
      const limit = 3 / magnitude;
      tangents[i] *= limit;
      tangents[i + 1] *= limit;
    }
  });
  return points.slice(1).reduce((path, p, i) => {
    const previous = points[i];
    const third = (p.x - previous.x) / 3;
    return `${path} C${previous.x + third},${previous.y + tangents[i] * third} ${p.x - third},${p.y - tangents[i + 1] * third} ${p.x},${p.y}`;
  }, `M${points[0].x},${points[0].y}`);
}
